import CustomText from "../atomic/CustomText";
import SCCClinicalInformationReview from "../global/forms/OnlineOrderReviews/SCCClinicalInformationReview";
import DetailRenderer from "../global/forms/DetailRenderer";

const processClinicalInfo = (data: any, testType: any) => {
  if (testType?.test === 8) {
    return {
      ...data,
      isAltheaDxNeuropsychotropicMedications:
        data?.isAltheaDxNeuropsychotropicMedications?.join(", "),
      isIDgNeuropsychotropicMedicationsCurrent:
        data?.isIDgNeuropsychotropicMedicationsCurrent?.join(", "),
      isIDgOTCHerbalMedsEnvironmentalFactorDietarySupplement:
        data?.isIDgOTCHerbalMedsEnvironmentalFactorDietarySupplement?.join(
          ", "
        ),
    };
  }

  return data;
};

const ClinicalInformation = ({ order }: any) => (
  <div id="clinical info">
    <CustomText
      text={`${order?.testType?.test === 8
        ? "Patient Healthcare Information"
        : "Clinical Information"
        } `}
      fontWeight="font-medium"
      className="reviewCardHeading my-5"
    />
    <div className="reviewCard">
      {order?.testType?.test === 2 && (
        <SCCClinicalInformationReview
          values={{
            historyPhysicalExam: order.historyPhysicalExam,
            pathologySurgicalFindings: order.pathologySurgicalFindings,
          }}
          approval
          mainHeading="Clinical Information"
          approvalSectionUrl={`/access/online-order/${order.supportingSection.id}#Clinical%20Information`}
        />
      )}

      {(order?.testType?.test === 3 || order?.testType?.test === 6) && (
        <DetailRenderer
          data={order.clinicalInfoId3Melanoma}
          groupFields={[
            "isSentinelLymphNodeBiopsy",
            "lymphNodeStatus",
            "isClinicallyPalpableNodes",
            "isIntrasitMetastasis",
          ]}
          hiddenFields={[]}
          MainHeading="Clinical Information"
          approval={true}
          approvalSectionUrl={`${`/access/online-order/${order.supportingSection.id}#Clinical%20Information`}`}
        />
      )}
      {order?.testType?.test === 4 && (
        <DetailRenderer
          data={order.clinicialInfoId4UMUMSeq}
          groupFields={["isExposedToRadiation", "isReportPrame"]}
          hiddenFields={[]}
          MainHeading="Clinical Information"
          approval={true}
          approvalSectionUrl={`${`/access/online-order/${order.supportingSection.id}#Clinical%20Information`}`}
        />
      )}
      {order?.testType?.test === 5 && (
        <DetailRenderer
          data={order.clinicalInfoId5DDM}
          groupFields={["isPrimaryCutaneousMelanocyticNeoplasm"]}
          hiddenFields={[]}
          MainHeading="Clinical Information"
          approval={true}
          approvalSectionUrl={`${`/access/online-order/${order.supportingSection.id}#Clinical%20Information`}`}
        />
      )}
      {order?.testType?.test === 8 && (
        <DetailRenderer
          data={processClinicalInfo(order.clinicalInfoId8IDG, order.testType)}
          groupFields={[
            "isAltheaDxNeuropsychotropicMedications",
            "isIDgNeuropsychotropicMedicationsCurrent",
            "isIDgOTCHerbalMedsEnvironmentalFactorDietarySupplement",
          ]}
          hiddenFields={[]}
          MainHeading="Patient Healthcare Information"
          approval={true}
          approvalSectionUrl={`${`/access/online-order/${order.supportingSection.id}#Patient%20Healthcare%20Information`}`}
        />
      )}
      {order?.testType?.test === 9 && (
        <DetailRenderer
          data={{ isConsideredForTherapy: order?.isConsideredForTherapy }}
          groupFields={["isConsideredForTherapy"]}
          hiddenFields={[]}
          MainHeading="Clinical Information"
          approval={true}
          approvalSectionUrl={`${`/access/online-order/${order.supportingSection.id}#Clinical%20Information`}`}
        />
      )}
    </div>
  </div>
);

export default ClinicalInformation;
